import { Area, Country } from '../../../base/interfaces/config';
import { ProfileDataParams } from './api/interfaces';
import { Fields as RecruiterProfileFields } from './redux/slice/profileSlice';

export const mapApiProfileDataToState = (
    { areasIds, countriesIds, image, imageUrl, city, ...data }: ProfileDataParams,
    configCountries: Country[],
    configAreas: Area[],
): RecruiterProfileFields => ({
    countries: configCountries.filter((country) => countriesIds.includes(country.id)),
    areas: configAreas.filter((area) => areasIds.includes(area.id)),
    image: (image as File) || null,
    imageUrl: imageUrl || null,
    city: city || null,
    ...data,
});

export const mapProfileDataStateToApiParams = (data: RecruiterProfileFields): ProfileDataParams => ({
    id: data.id as number,
    image: data.image || '',
    name: data.name,
    cityId: (data.city?.id as number) || -1,
    phone: data.phone,
    type: data.type,
    agencyName: data.agencyName,
    website: data.website,
    description: data.description,
    areasIds: data.areas.map((area) => area.id),
    countriesIds: data.countries.map((country) => country.id),
});
